import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { AppUtilityService } from 'src/app/app-utility.service';
import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';

import { LmsTableWrapperComponent } from '@lmsShared';
import { LmsModalFrameComponent } from '@lmsSharedUI';

async function loadXLSX() {
  const XLSX = await import('xlsx');
  return XLSX;
}

@Component({
  selector: 'app-lexis-nexis-report',
  templateUrl: './lexis-nexis-report.component.html',
  styleUrls: ['./lexis-nexis-report.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    LmsModalFrameComponent,
    LmsTableWrapperComponent
  ],
})
export class LexisNexisReportComponent {
  lmsDataReportList: any[] = [];

  reportTitle: string = 'Lexis Nexis Report';
  startDate: string;
  endDate: string;

  fileName = '';
  @ViewChild('TABLE') table: ElementRef;

  config: PaginationInstance = {
    id: 'lexis-nexis-report-pager',
    itemsPerPage: 15,
    currentPage: 1,
  };
  constructor(
    public global_utility: AppUtilityService,
    public dialogRef: MdbModalRef<LexisNexisReportComponent>,
  ) {}

  exportToExcel(): void {
    this.fileName = `LexisNexisReport_${new Date()
      .toISOString()
      .slice(0, 10)}.xlsx`;
    this.global_utility.startLoading('Exporting data to Excel...');
    loadXLSX()
      .then((XLSX) => {
        const ws = XLSX.utils.table_to_sheet(this.table.nativeElement);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Lexis Nexis Report');
        XLSX.writeFile(wb, this.fileName);
        this.global_utility.stopLoading();
      })
      .catch((err) => {
        this.global_utility.stopLoading();
        this.global_utility.error('Failed to export Excel: ' + err);
      });
  }

  close() {
    this.dialogRef.close();
  }
}
